import { render, staticRenderFns } from "./CedulaSospechaCancer.vue?vue&type=template&id=5ceb60c6&"
import script from "./CedulaSospechaCancer.vue?vue&type=script&lang=js&"
export * from "./CedulaSospechaCancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports